export class StringHelper {
	/**
	 * Capitalizes the first letter for each word and sets the rest to lowercase
	 * @param str
	 */
	public static toTitleCase(str) {
		return str.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
	}

	/**
	 * Capitalizes the first letter of a string
	 * @param str
	 */
	public static capitalize(str: string): string {
		return str.charAt(0).toUpperCase() + str.slice(1);
	}

	/**
	 * Removes char code 8232 as it causes doc gen failures
	 * @param str
	 */
	public static cleanString(str: string): string {
		return str.replace(/\u2028/g, '').trim();
	}

	/**
	 * Checks if a string contains a URL, and if so, replaces the URL with a html hyperlink
	 * @param str
	 */
	public static checkStringForURL(str: string) {
		const urlRegex = /\b((https?:\/\/|www\.)[^\s<]+|[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/[^\s<]*)?)/gi;

		return str.replace(urlRegex, function (match) {
			let url = match;

			// add protocol if missing
			if (!url.startsWith('http://') && !url.startsWith('https://')) {
				url = 'https://' + match;
			}

			return `<a href="${url}" target="_blank" rel="noopener noreffer nofollow">${match}</a>`;
		});
	}
}
